import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    items: {}
  }),
  getters: {
    byType: state => type => {
      const items = Object.values(state.items)
      return items.filter((item) => {
        return item.type === type
      })
    }
  },
  mutations: {
    set (
      state,
      {
        id,
        patient_id,
        type,
        value,
        created_at,
        created_by
      }
    ) {
      if (!state.items[id]) {
        Vue.set(state.items, id, {})
      }
      Vue.set(state.items[id], 'id', id)
      Vue.set(state.items[id], 'patient_id', patient_id)
      Vue.set(state.items[id], 'type', type)
      Vue.set(state.items[id], 'value', value)
      Vue.set(state.items[id], 'created_at', created_at)
      Vue.set(state.items[id], 'created_by', created_by)
    },
    remove (state, id) {
      Vue.delete(state.items, id)
    },
    reset (state) {
      Vue.set(state, 'items', {})
    }
  }
}
